import React from 'react';

//Redux
import { useSelector } from 'react-redux';

//Bootstrap
import { Container, Row } from 'react-bootstrap';

//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faPhoneAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
// import { faDownload } from '@fortawesome/free-solid-svg-icons';

import './Contacto.css';
import Title from '../../../components/Title/Title';
// import ContactFormItem from '../../../components/Contact/ContactFormItem/ContactFormItem';
// import ContactList from '../../../components/Contact/ContactList/ContactList';
import SocialButtons from '../../../components/SocialButtons/SocialButtons';
import InfoCustomCard from '../../../components/InfoCustomCard/InfoCustomCard';

const iconArr = [faLinkedin, faEnvelope, faPhoneAlt, faMapMarkerAlt];

const Contacto = () => {
    // const contactScreen = useSelector(state => state.data.generalProps.contactScreen);
    const personalInfo = useSelector(state => state.data.personalInfo);
    const socialNetwork = useSelector(state => state.data.socialNetworks);

    const contactInfo = personalInfo ?
        [
            { id: personalInfo[6].ID, value: decodeURIComponent(personalInfo[6].VALOR), icon: decodeURIComponent(personalInfo[6].TITULO_LABEL_HTML), href: decodeURIComponent(personalInfo[6].HREF) },
            { id: personalInfo[7].ID, value: decodeURIComponent(personalInfo[7].VALOR), icon: decodeURIComponent(personalInfo[7].TITULO_LABEL_HTML), href: decodeURIComponent(personalInfo[7].HREF) },
            { id: personalInfo[13].ID, value: decodeURIComponent(personalInfo[13].VALOR), icon: decodeURIComponent(personalInfo[13].TITULO_LABEL_HTML), href: decodeURIComponent(personalInfo[13].HREF) },
            { id: personalInfo[8].ID, value: decodeURIComponent(personalInfo[8].VALOR), icon: decodeURIComponent(personalInfo[8].TITULO_LABEL_HTML), href: null }
        ] : null;
    // const cv = personalInfo ? `./assets/docs/${parse(decodeURIComponent(personalInfo[16].VALOR))}` : null;

    // const contactData = personalInfo ? [
    //     { id: personalInfo[6].ID, title: decodeURIComponent(personalInfo[6].NOMBRE), value: decodeURIComponent(personalInfo[6].VALOR) },
    //     { id: personalInfo[7].ID, title: decodeURIComponent(personalInfo[7].NOMBRE), value: decodeURIComponent(personalInfo[7].VALOR) },
    //     { id: personalInfo[8].ID, title: decodeURIComponent(personalInfo[8].NOMBRE), value: decodeURIComponent(personalInfo[8].VALOR) }
    // ] : null;

    // const emailTo = personalInfo ? decodeURIComponent(personalInfo[6].VALOR) : null;

    // contactScreen.contactForm[1].validationRegister.pattern.value = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
    // const { register, handleSubmit, errors } = useForm();
    // const [error, setError] = useState(false);
    // const [messageResponse, setMessageResponse] = useState(null);
    // const [loading, setLoading] = useState(false);

    // const onSubmit = useCallback(async (data) => {
    //     if(!emailTo){
    //         setError(true);
    //         setMessageResponse("Ha ocurrido un error al intentar enviar el mensaje. Por favor, intente en unos minutos.");
    //         return;
    //     }
    //     const formData = new FormData();
    //     formData.append('toMail', emailTo);
    //     formData.append('name', data.name);
    //     formData.append('email', data.email);
    //     formData.append('phone', data.phone);
    //     formData.append('message', data.message);
    //     setError(false);
    //     setMessageResponse(null);
    //     setLoading(true);
    //     try {
    //         // const response = await axios.post('http://www.prostringmachine.com/php/sendmail.php', formData);
    //         const response = {
    //             data: {
    //                 error: true,
    //                 message: "Estamos en modo prueba y la url no está asignada"
    //             }
    //         }
    //         setLoading(false);
    //         setError(response.data.error);
    //         setMessageResponse(response.data.message);
    //     } catch (err) {
    //         setError(true);
    //         setMessageResponse(err.message);
    //         setLoading(false);
    //     }
    // }, [emailTo]);

    return (
        <Container fluid className="py-5 text-center">
            <div className="pb-5">
                <Title textLight="Póngase en " textBold="Contacto" titleType="h1" />
            </div>
            <SocialButtons data={socialNetwork} />
            <Row className="px-5 py-4 justify-content-around text-align-center text-left">
                <InfoCustomCard id="info" title="Información" classes="my-3 my-md-0" flex={{ md: "5" }}>
                    {contactInfo ?
                        contactInfo.map(s => {
                            const icon = iconArr.find(i => i.iconName === s.icon);
                            return <p key={s.id} className="custom-description d-flex align-items-center py-2 text-break">
                                <FontAwesomeIcon icon={icon} className="mr-4 custom-social-info" />
                                {s.href ?
                                    <a className="custom-normal-link" href={s.href} target="_blank" rel="noopener noreferrer">
                                        {s.value}
                                    </a>
                                    :
                                    <React.Fragment>{s.value}</React.Fragment>
                                }
                            </p>
                        })
                        :
                        null
                    }

                    {/* <a href={cv} target="_blank" rel="noopener noreferrer" className="btn custom-btn px-sm-4 py-sm-3 px-3 py-2 mt-4 mb-3"><FontAwesomeIcon icon={faDownload} className="mr-2" />Descargar CV</a> */}
                </InfoCustomCard>
            </Row>
            {/* <Row className="p-5 justify-content-center">
                <Col md="7" lg="6" xl="5" className="mb-5 mb-md-0">
                    <form className="custom-form" onSubmit={handleSubmit(onSubmit)}>
                        <h3 className="mb-4 custom-header">Contáctame</h3>
                        {contactScreen.contactForm.map(c => {
                            let errorMessage = null;
                            for (const k in errors) {
                                if (k === c.id) {
                                    errorMessage = errors[k].message ? errors[k].message : null;
                                }
                            }
                            return (
                                <React.Fragment key={c.id}>
                                    <ContactFormItem {...c} reference={register} errorMessage={errorMessage} fromContact={true} />
                                </React.Fragment>
                            )
                        })}
                        <div className="form-group mt-5">
                            <button type="submit" className="btn custom-btn px-4 py-3">
                                {loading ? <div className="spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                </div> : "Enviar mensaje"}
                            </button>
                        </div>
                        {messageResponse ?
                            error ?
                                <span className="custom-error-message">{messageResponse}</span>
                                :
                                <span className="custom-success-message">{messageResponse}</span>
                            : null}
                    </form>
                </Col>
                <Col md="5" lg="4" xl="3" className="pl-md-5 mt-3 mb-mt-0">
                    <h3 className="mb-4 custom-header">Mis datos</h3>
                    {contactData ? <ContactList list={contactData} /> : null}
                </Col>
            </Row> */}
        </Container >
    );
};

export const componentName = "Contacto";
export default Contacto;